import * as Yup from 'yup';

// Same field rules as consultSchema.js, minus location/description — the
// on-page form only collects contact info; clinic selection and questions
// happen inside the self-schedule app after handoff.
export const onPageSelfScheduleSchema = Yup.object().shape({
    first_name: Yup.string()
        .required('Required')
        .matches(/^(?!\s*$).+$/, 'Only spaces are not allowed'),
    last_name: Yup.string()
        .required('Required')
        .matches(/^(?!\s*$).+$/, 'Only spaces are not allowed'),
    email: Yup.string()
        .email('Invalid email')
        .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Invalid email')
        .required('Required'),
    phone: Yup.string().min(15, 'Invalid phone number').required('Required'),
    intent: Yup.string(),
});
